export enum AppKeys {
  Documents = 'LIFEN-DOCUMENTS',
  Integrations = 'LIFEN-INTEGRATIONS',
  MedicalVisa = 'LIFEN-MEDICAL-VISA',
}

export enum MainRouteUrls {
  DesktopSettings = 'desktop-settings',
  Documents = 'documents',
  Integrations = 'integrations',
  Maintenance = 'maintenance',
  MedicalVisa = 'medical-visa',
}

export enum AppHomeRouteUrls {
  DesktopSettings = 'desktop-settings',
  Documents = 'documents/draft',
  Integrations = 'integrations',
  MedicalVisa = 'medical-visa',
}

export type CoreApp = {
  id: string;
  displayName: string;
  iconUrl: string;
  storeIcon: string;
  path: MainRouteUrls;
  name: AppKeys;
};
